import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 13v4h44v-3L10 13zM12 8v3h40V8H12zM8 19v37h48V20L8 19zM26 48V28l16.857 10L26 48z" })
});
export default SvgVideo;
